const { Dependencies, StringHelper, Override } = require("@bryntum/gantt");
import TemplateHelper from "@bryntum/gantt/source/lib/Core/helper/TemplateHelper";

const fromBoxSide = [
    'left',
    'left',
    'right',
    'right'
],
toBoxSide = [
    'left',
    'right',
    'left',
    'right'
];

class DepFeatureOverride  {
    static get target() {
        return {
            class      : Dependencies,
            product    : 'grid',
            minVersion : '1.0',
            maxVersion : '5.0.7'
        };
    }
    getHoverTipHtml({ activeTarget }) {
        const
            me                = this,
            dependencyModel   = me.resolveDependencyRecord(activeTarget)
        if (!dependencyModel) {
            return null;
        }

        const
            { fromEvent, toEvent } = dependencyModel,
            lagStr                 = dependencyModel.lag ? `<tr>
                    <td>${me.L('L{DependencyEdit.Lag}')}: </td>
                    <td>${StringHelper.encodeHtml(dependencyModel.fullLag)}</td>
                    <td></td>
                </tr>` : '';

        return TemplateHelper.tpl`
             <table class="b-sch-dependency-tooltip">
                <tr>
                    <td>${me.L('L{Dependencies.from}')}: </td>
                    <td>${StringHelper.encodeHtml(fromEvent.name)}</td>
                    <td><div class="b-sch-box b-${fromBoxSide[dependencyModel.type]}"></div></td>
                </tr>
                <tr>
                    <td>${me.L('L{Dependencies.to}')}: </td>
                    <td>${StringHelper.encodeHtml(toEvent.name)}</td>
                    <td><div class="b-sch-box b-${toBoxSide[dependencyModel.type]}"></div></td>
                </tr>
                 ${lagStr}
            </table>
        `;
    }
}

Override.apply(DepFeatureOverride);
